import { useWebSocket } from '../contexts/WebSocketContext';

const WebSocketStatus = () => {
  const { connectionStatus, isConnected, notifications } = useWebSocket();

  const getStatusColor = () => {
    switch (connectionStatus) {
      case 'connected':
        return 'bg-green-500';
      case 'connecting':
        return 'bg-yellow-500';
      case 'disconnected':
        return 'bg-red-500';
      case 'error':
        return 'bg-red-600';
      default:
        return 'bg-gray-500';
    }
  };

  const getStatusText = () => {
    switch (connectionStatus) {
      case 'connected':
        return 'Live';
      case 'connecting':
        return 'Connecting...';
      case 'disconnected':
        return 'Offline';
      case 'error':
        return 'Error';
      default:
        return 'Unknown';
    }
  };

  return (
    <div className="flex items-center space-x-2">
      {/* Connection Status Indicator */}
      <div className="flex items-center space-x-1">
        <div className={`w-2 h-2 rounded-full ${getStatusColor()} ${isConnected ? 'animate-pulse' : ''}`}></div>
        <span className="text-xs text-gray-600">{getStatusText()}</span>
      </div>

      {/* Notification Badge */}
      {notifications.length > 0 && (
        <div className="relative">
          <div className="w-4 h-4 bg-red-500 rounded-full flex items-center justify-center">
            <span className="text-xs text-white font-bold">
              {notifications.length > 9 ? '9+' : notifications.length}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default WebSocketStatus;